<template>
    <div class="vp-message">
        <h2 class="vp-heading vp-message-title">{{ t("Video unavailable") }}</h2>
        <p class="vp-message-body">{{ t("This video can't be played right now. Please try again later.") }}</p>
    </div>
</template>

<script setup>
import { useCoreI18n } from "../useCoreI18n.js"

const t = useCoreI18n()
</script>
